import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { Alert, Button, Typography } from '@mui/material'
import type { FC } from 'react'
import styled from 'styled-components'

import ActionButton from '@/components/ActionButton'
import H6 from '@/components/H6'
import type { Document } from '@/lib/apollo/query/get-applicant'

import PreviewDocument from './PreviewDocument'

interface Props {
  documents: Document[]
  onEdit: () => void
}

const Container = styled.div`
  display: grid;
  gap: 10px;
`

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 140px;
  gap: 10px;
`

const IdEvidenceSummary: FC<Props> = ({ documents, onEdit }) => (
  <Container>
    <HeaderContainer>
      <H6>Proof of ID</H6>{' '}
      <ActionButton label="Change proof of ID" icon={faPenToSquare} onClick={onEdit} />
    </HeaderContainer>
    {documents.length === 0 ? (
      <Alert severity="warning">
        <Typography>
          No ID Evidence selected. Please ensure you select ID evidence before verifying.
        </Typography>
        <Button
          sx={{ padding: '15px', marginTop: '15px' }}
          color="warning"
          variant="contained"
          onClick={onEdit}
        >
          Select ID Evidence
        </Button>
      </Alert>
    ) : (
      documents.map((document, i) => <PreviewDocument key={i} document={document} />)
    )}
  </Container>
)

export default IdEvidenceSummary
